(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4852,347],{

/***/ 39355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports gql, resetCaches, disableFragmentWarnings, enableExperimentalFragmentVariables, disableExperimentalFragmentVariables */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16898);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39418);


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = (0,graphql__WEBPACK_IMPORTED_MODULE_1__/* .parse */ .Qc)(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ __webpack_exports__["ZP"] = (gql);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 12236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/channels",
      function () {
        return __webpack_require__(25590);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AppNavigation_AppNavigation; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@saleor+macaw-ui@0.6.7_vdvb7n236vx4s4shxyxtl27fte/node_modules/@saleor/macaw-ui/dist/esm/index.js + 57 modules
var esm = __webpack_require__(50145);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.4_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(13220);
// EXTERNAL MODULE: ./routes.ts
var routes = __webpack_require__(57032);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-intl@6.2.1_uz2ogxeagc4rbieizlfzyaazee/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(74622);
// EXTERNAL MODULE: ./frontend/misc/commonMessages.ts
var commonMessages = __webpack_require__(17745);
;// CONCATENATED MODULE: ./frontend/components/elements/AppNavigation/styles.tsx

const useStyles = (0,esm/* makeStyles */.ZL)((theme)=>({
        tabs: {
            marginBottom: theme.spacing(2)
        }
    }), {
    name: "AppNavigation"
});

;// CONCATENATED MODULE: ./frontend/components/elements/AppNavigation/AppNavigation.tsx







const AppNavigation = ()=>{
    const router = (0,next_router.useRouter)();
    const intl = (0,useIntl/* default */.Z)();
    const classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* PageTabs */.hGv, {
        onChange: (route)=>{
            void router.push(route);
        },
        value: router.pathname,
        className: classes.tabs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* PageTab */._Z$, {
                value: routes/* channelListPath */.$N,
                label: intl.formatMessage(commonMessages/* sectionMessages.channels */.W.channels)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* PageTab */._Z$, {
                value: routes/* customizationPath */.CG,
                label: intl.formatMessage(commonMessages/* sectionMessages.customization */.W.customization)
            })
        ]
    });
};
/* harmony default export */ var AppNavigation_AppNavigation = (AppNavigation);

;// CONCATENATED MODULE: ./frontend/components/elements/AppNavigation/index.ts




/***/ }),

/***/ 60347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ClientAppBridgeProvider": function() { return /* binding */ ClientAppBridgeProvider; },
  "useAppContext": function() { return /* binding */ useAppContext; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@urql+exchange-auth@1.0.0_graphql@16.6.0/node_modules/@urql/exchange-auth/dist/urql-exchange-auth.mjs
var urql_exchange_auth = __webpack_require__(72102);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@urql+exchange-multipart-fetch@1.0.1_graphql@16.6.0/node_modules/@urql/exchange-multipart-fetch/dist/urql-exchange-multipart-fetch.mjs
var urql_exchange_multipart_fetch = __webpack_require__(17091);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@urql+core@3.0.5_graphql@16.6.0/node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(17677);
;// CONCATENATED MODULE: ./frontend/misc/client.ts



const addAuthToOperation = (param)=>{
    let { authState , operation  } = param;
    if (!(authState === null || authState === void 0 ? void 0 : authState.token)) {
        return operation;
    }
    const fetchOptions = typeof operation.context.fetchOptions === "function" ? operation.context.fetchOptions() : operation.context.fetchOptions || {};
    return (0,urql_core/* makeOperation */.vx)(operation.kind, operation, {
        ...operation.context,
        fetchOptions: {
            ...fetchOptions,
            headers: {
                ...fetchOptions.headers,
                Authorization: "Bearer ".concat(authState.token)
            }
        }
    });
};
const willAuthError = (param)=>{
    let { authState  } = param;
    return !(authState === null || authState === void 0 ? void 0 : authState.token);
};
const createGraphqlClient = (apiUrl, token)=>{
    console.info("Using API_URL: ".concat(apiUrl));
    return (0,urql_core/* createClient */.eI)({
        exchanges: [
            urql_core/* dedupExchange */.B5,
            urql_core/* cacheExchange */.HG,
            (0,urql_exchange_auth/* authExchange */.M)({
                getAuth: async ()=>token ? {
                        token
                    } : null,
                willAuthError,
                addAuthToOperation
            }),
            urql_exchange_multipart_fetch/* multipartFetchExchange */.i
        ],
        url: apiUrl
    });
};

// EXTERNAL MODULE: ./frontend/misc/createSafeContext.ts
var createSafeContext = __webpack_require__(58727);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@saleor+app-sdk@0.23.0_dcors23iqtgxrhrwosgnnc4xji/node_modules/@saleor/app-sdk/app-bridge/index.mjs + 73 modules
var app_bridge = __webpack_require__(19036);
// EXTERNAL MODULE: ../../node_modules/.pnpm/urql@3.0.3_onqnqwb3ubg5opvemcqf7c2qhy/node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(28825);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./frontend/utils.ts
var utils = __webpack_require__(22058);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.4_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(13220);
;// CONCATENATED MODULE: ./frontend/components/elements/AppProvider/useSynchronizedAppBridgePaths.tsx




const useSynchronizedAppBridgePaths = (app)=>{
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const handleRouteChange = (path)=>{
            const rawPath = (0,utils/* getRawAppPath */.TM)(path);
            void app.dispatch(app_bridge/* actions.Redirect */.Nw.Redirect({
                to: "/apps/".concat(encodeURIComponent(app.getState().id), "/app").concat(rawPath)
            }));
        };
        const unsubscribe = app.subscribe(app_bridge/* EventType.redirect */.tw.redirect, (param)=>{
            let { path  } = param;
            if (path && path !== router.pathname) {
                void router.push(path);
            }
        });
        router.events.on("routeChangeComplete", handleRouteChange);
        return ()=>{
            unsubscribe();
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        app,
        router
    ]);
};

;// CONCATENATED MODULE: ./frontend/components/elements/AppProvider/useSubscribeToIsAuthorized.tsx


const useSubscribeToIsAuthorized = (app)=>{
    const [isAuthorized, setIsAuthorized] = (0,react.useState)(!!app.getState().token);
    (0,react.useEffect)(()=>{
        if (app) {
            setIsAuthorized(!!app.getState().token);
            const unsubscribe = app.subscribe(app_bridge/* EventType.handshake */.tw.handshake, (payload)=>{
                setIsAuthorized(!!payload.token);
            });
            return ()=>{
                unsubscribe();
            };
        }
    }, [
        app
    ]);
    return isAuthorized;
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/ts-invariant@0.10.3/node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(67558);
;// CONCATENATED MODULE: ./frontend/components/elements/AppProvider/ClientAppBridgeProvider.tsx









// appBridge instance needs to be created before the first render
// otherwise, we never get the "handshake" event or the token
const appBridge = typeof document === "undefined" ? null : new app_bridge/* AppBridge */.rU();
const [useAppContext, AppContextProvider] = (0,createSafeContext/* default */.Z)();

const ClientAppBridgeProvider = (param)=>{
    let { children  } = param;
    const app = appBridge;
    (0,invariant/* default */.ZP)(app, "ClientAppBridgeProvider is not available on the server side");
    const isAuthorized = useSubscribeToIsAuthorized(app);
    useSynchronizedAppBridgePaths(app);
    // @todo use `saleorApiUrl`
    const { domain , token  } = app.getState();
    const saleorApiUrl = "https://".concat(domain, "/graphql/");
    const client = (0,react.useMemo)(()=>{
        return createGraphqlClient(saleorApiUrl, token);
    }, [
        saleorApiUrl,
        token
    ]);
    const appContext = (0,react.useMemo)(()=>({
            app,
            isAuthorized
        }), [
        app,
        isAuthorized
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(urql_es/* Provider */.zt, {
        value: client,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContextProvider, {
            value: appContext,
            children: children
        })
    });
};


/***/ }),

/***/ 73754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useAuthData; }
/* harmony export */ });
/* harmony import */ var _components_elements_AppProvider_ClientAppBridgeProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60347);

const useAuthData = ()=>{
    const { app , isAuthorized  } = (0,_components_elements_AppProvider_ClientAppBridgeProvider__WEBPACK_IMPORTED_MODULE_0__.useAppContext)();
    return {
        appId: app.getState().id,
        isAuthorized
    };
};


/***/ }),

/***/ 17745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ sectionMessages; }
/* harmony export */ });
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84841);

const sectionMessages = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    channels: {
        defaultMessage: "Channels",
        id: "misc/commonMessages/95qy1d",
        description: "section name"
    },
    customization: {
        defaultMessage: "Customization",
        id: "misc/commonMessages/gnUZny",
        description: "section name"
    },
    settings: {
        defaultMessage: "Settings",
        id: "misc/commonMessages/g8hTTQ",
        description: "section name"
    }
});


/***/ }),

/***/ 22058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jr": function() { return /* binding */ mapNodeToItem; },
/* harmony export */   "Mz": function() { return /* binding */ getCommonErrors; },
/* harmony export */   "N5": function() { return /* binding */ mapNodesToItems; },
/* harmony export */   "R5": function() { return /* binding */ flattenSettingId; },
/* harmony export */   "TM": function() { return /* binding */ getRawAppPath; },
/* harmony export */   "aN": function() { return /* binding */ unflattenSettings; },
/* harmony export */   "mJ": function() { return /* binding */ getMetafield; },
/* harmony export */   "wE": function() { return /* binding */ unflattenValue; }
/* harmony export */ });
const flattenSettingId = (groupId, optionIdx, settingId)=>"".concat(groupId, "-").concat(optionIdx, "-").concat(settingId);
const unflattenValue = (valueId, flattenedValues)=>{
    const valueKey = Object.keys(flattenedValues).find((flattedKey)=>{
        const keys = flattedKey.split("-");
        return keys[0] === valueId;
    });
    return valueKey && flattenedValues[valueKey];
};
const unflattenSettings = (groupId, flattenedValues, options)=>{
    const unflattenedSettings = {};
    Object.keys(flattenedValues).forEach((flattedKey)=>{
        var ref;
        const keys = flattedKey.split("-");
        if (keys[0] !== groupId) {
            return;
        }
        const mainKey = (ref = options[Number(keys[1])]) === null || ref === void 0 ? void 0 : ref.id;
        const subKey = keys[2];
        if (mainKey && subKey) {
            unflattenedSettings[mainKey] = {
                ...unflattenedSettings[mainKey],
                [subKey]: flattenedValues[flattedKey]
            };
        }
    });
    return unflattenedSettings;
};
const mapNodeToItem = (node)=>({
        id: node.id,
        label: node.name
    });
const mapNodesToItems = (nodes)=>{
    return (nodes === null || nodes === void 0 ? void 0 : nodes.map(mapNodeToItem)) || [];
};
const getCommonErrors = (error)=>{
    return (error === null || error === void 0 ? void 0 : error.graphQLErrors) || (error === null || error === void 0 ? void 0 : error.networkError) ? [
        ...(error === null || error === void 0 ? void 0 : error.graphQLErrors) || [],
        ...(error === null || error === void 0 ? void 0 : error.networkError) ? [
            error.networkError
        ] : []
    ] : [
        ...error ? [
            error
        ] : []
    ];
};
const getMetafield = (metafields, metafieldId)=>metafields[metafieldId];
const getRawAppPath = (path)=>{
    const trimmedQueryParams = path.split("?")[0];
    const trimmedLanguage = trimmedQueryParams.replace(/^\/[a-z]{2}(-[A-Z]{2})?(\/|$)/, "/");
    return trimmedLanguage;
};


/***/ }),

/***/ 32026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C6": function() { return /* binding */ useUpdatePublicMetadataMutation; },
/* harmony export */   "Ne": function() { return /* binding */ usePublicMetafieldsQuery; },
/* harmony export */   "jI": function() { return /* binding */ useChannelsQuery; },
/* harmony export */   "rk": function() { return /* binding */ useFileUploadMutation; }
/* harmony export */ });
/* unused harmony exports ChannelFragmentDoc, FileUploadErrorFragmentDoc, MetadataErrorFragmentDoc, AddressFragmentDoc, MoneyFragmentDoc, OrderLineFragmentDoc, OrderFragmentDoc, TransactionEventFragmentDoc, TransactionFragmentDoc, TransactionActionPayloadFragmentDoc, WebhookErrorFragmentDoc, AppDocument, useAppQuery, ChannelDocument, useChannelQuery, ChannelsDocument, CheckoutDocument, useCheckoutQuery, FileUploadDocument, PublicMetafieldsDocument, PrivateMetafieldsDocument, usePrivateMetafieldsQuery, PublicMetafieldsInferedDocument, usePublicMetafieldsInferedQuery, PrivateMetafieldsInferedDocument, usePrivateMetafieldsInferedQuery, UpdatePublicMetadataDocument, UpdatePrivateMetadataDocument, useUpdatePrivateMetadataMutation, OrderCreateDocument, useOrderCreateMutation, OrderDetailsDocument, useOrderDetailsQuery, OrderPaymentDetailsDocument, useOrderPaymentDetailsQuery, OrderUpdatePaymentMetafieldDocument, useOrderUpdatePaymentMetafieldMutation, OrderTransactionsDocument, useOrderTransactionsQuery, TransactionCreateDocument, useTransactionCreateMutation, TransactionUpdateDocument, useTransactionUpdateMutation, TransactionProcessedEventsDocument, useTransactionProcessedEventsQuery, TransactionUpdateProcessedEventsDocument, useTransactionUpdateProcessedEventsMutation, TransactionActionRequestSubscriptionDocument, useTransactionActionRequestSubscription, CreateWebhooksDocument, useCreateWebhooksMutation, CheckWebhooksDocument, useCheckWebhooksQuery */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15771);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39355);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28825);
// THIS FILE IS GENERATED WITH `pnpm generate`

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ChannelFragment on Channel {\n    id\n    name\n    slug\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment FileUploadErrorFragment on UploadError {\n    code\n    message\n    field\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment MetadataErrorFragment on MetadataError {\n    code\n    message\n    field\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment Address on Address {\n    companyName\n    firstName\n    lastName\n    streetAddress1\n    streetAddress2\n    postalCode\n    city\n    country {\n      code\n    }\n    countryArea\n    phone\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment Money on Money {\n    currency\n    amount\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment OrderLine on OrderLine {\n    id\n    productName\n    variantName\n    quantity\n    taxRate\n    variant {\n      product {\n        category {\n          name\n        }\n        productType {\n          isDigital\n          kind\n        }\n      }\n    }\n    unitPrice {\n      gross {\n        ...Money\n      }\n    }\n    totalPrice {\n      gross {\n        ...Money\n      }\n      net {\n        ...Money\n      }\n      tax {\n        ...Money\n      }\n    }\n    thumbnail {\n      url\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  fragment Order on Order {\n    id\n    number\n    userEmail\n    billingAddress {\n      ...Address\n    }\n    shippingAddress {\n      ...Address\n    }\n    total {\n      gross {\n        ...Money\n      }\n    }\n    discounts {\n      name\n      amount {\n        ...Money\n      }\n    }\n    shippingPrice {\n      gross {\n        ...Money\n      }\n      net {\n        ...Money\n      }\n      tax {\n        ...Money\n      }\n    }\n    shippingTaxRate\n    shippingMethodName\n    privateMetafield(key: "payment")\n    lines {\n      ...OrderLine\n    }\n  }\n  ',
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment TransactionEvent on TransactionEvent {\n    name\n    reference\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment Transaction on TransactionItem {\n    id\n    reference\n    voidedAmount {\n      ...Money\n    }\n    refundedAmount {\n      ...Money\n    }\n    chargedAmount {\n      ...Money\n    }\n    authorizedAmount {\n      ...Money\n    }\n    events {\n      ...TransactionEvent\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment TransactionActionPayload on TransactionActionRequest {\n    transaction {\n      id\n      reference\n      type\n      authorizedAmount {\n        amount\n        currency\n      }\n      chargedAmount {\n        amount\n      }\n      voidedAmount {\n        amount\n      }\n      refundedAmount {\n        amount\n      }\n    }\n    action {\n      actionType\n      amount\n    }\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment WebhookErrorFragment on WebhookError {\n    message\n    field\n    code\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query App {\n    app {\n      id\n      name\n    }\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Channel($id: ID!) {\n    channel(id: $id) {\n      ...ChannelFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Channels {\n    channels {\n      ...ChannelFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Checkout($id: ID!) {\n    checkout(id: $id) {\n      id\n      totalPrice {\n        gross {\n          ...Money\n        }\n        net {\n          ...Money\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation FileUpload($file: Upload!) {\n    fileUpload(file: $file) {\n      uploadedFile {\n        url\n        contentType\n      }\n      errors {\n        ...FileUploadErrorFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PublicMetafields($id: ID!, $keys: [String!]) {\n    app(id: $id) {\n      id\n      metafields(keys: $keys)\n    }\n  }\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PrivateMetafields($id: ID!, $keys: [String!]) {\n    app(id: $id) {\n      id\n      privateMetafields(keys: $keys)\n    }\n  }\n"
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PublicMetafieldsInfered($keys: [String!]) {\n    app {\n      id\n      metafields(keys: $keys)\n    }\n  }\n"
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PrivateMetafieldsInfered($keys: [String!]) {\n    app {\n      id\n      privateMetafields(keys: $keys)\n    }\n  }\n"
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UpdatePublicMetadata($id: ID!, $input: [MetadataInput!]!, $keys: [String!]) {\n    updateMetadata(id: $id, input: $input) {\n      item {\n        metafields(keys: $keys)\n      }\n      errors {\n        ...MetadataErrorFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UpdatePrivateMetadata($id: ID!, $input: [MetadataInput!]!, $keys: [String!]) {\n    updatePrivateMetadata(id: $id, input: $input) {\n      item {\n        privateMetafields(keys: $keys)\n      }\n      errors {\n        ...MetadataErrorFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject21 = function() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation OrderCreate($id: ID!) {\n    orderCreateFromCheckout(id: $id) {\n      order {\n        ...Order\n      }\n      errors {\n        code\n        message\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject22 = function() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query OrderDetails($id: ID!) {\n    order(id: $id) {\n      ...Order\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject23 = function() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query OrderPaymentDetails($id: ID!) {\n    order(id: $id) {\n      authorizeStatus\n      chargeStatus\n      isPaid\n      status\n      privateMetafield(key: "payment")\n    }\n  }\n'
    ]);
    _templateObject24 = function() {
        return data;
    };
    return data;
}
function _templateObject25() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  mutation OrderUpdatePaymentMetafield($orderId: ID!, $data: String!) {\n    updatePrivateMetadata(id: $orderId, input: { key: "payment", value: $data }) {\n      errors {\n        code\n      }\n    }\n  }\n'
    ]);
    _templateObject25 = function() {
        return data;
    };
    return data;
}
function _templateObject26() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query OrderTransactions($id: ID!) {\n    order(id: $id) {\n      transactions {\n        ...Transaction\n      }\n      errors {\n        code\n        message\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject26 = function() {
        return data;
    };
    return data;
}
function _templateObject27() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation TransactionCreate(\n    $id: ID!\n    $transaction: TransactionCreateInput!\n    $transactionEvent: TransactionEventInput\n  ) {\n    transactionCreate(id: $id, transaction: $transaction, transactionEvent: $transactionEvent) {\n      transaction {\n        id\n      }\n      errors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject27 = function() {
        return data;
    };
    return data;
}
function _templateObject28() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation TransactionUpdate(\n    $id: ID!\n    $transaction: TransactionUpdateInput!\n    $transactionEvent: TransactionEventInput\n  ) {\n    transactionUpdate(id: $id, transaction: $transaction, transactionEvent: $transactionEvent) {\n      transaction {\n        id\n      }\n      errors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject28 = function() {
        return data;
    };
    return data;
}
function _templateObject29() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query TransactionProcessedEvents($id: ID!) {\n    transaction(id: $id) {\n      processedEvents: metafield(key: "processedEvents")\n    }\n  }\n'
    ]);
    _templateObject29 = function() {
        return data;
    };
    return data;
}
function _templateObject30() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  mutation TransactionUpdateProcessedEvents($id: ID!, $input: String!) {\n    updateMetadata(id: $id, input: { key: "processedEvents", value: $input }) {\n      errors {\n        code\n        field\n        message\n      }\n    }\n  }\n'
    ]);
    _templateObject30 = function() {
        return data;
    };
    return data;
}
function _templateObject31() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  subscription TransactionActionRequestSubscription {\n    event {\n      ... on TransactionActionRequest {\n        transaction {\n          id\n          reference\n          type\n          authorizedAmount {\n            amount\n            currency\n          }\n          chargedAmount {\n            amount\n          }\n          voidedAmount {\n            amount\n          }\n          refundedAmount {\n            amount\n          }\n        }\n        action {\n          actionType\n          amount\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject31 = function() {
        return data;
    };
    return data;
}
function _templateObject32() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  mutation CreateWebhooks($targetUrl: String, $query: String) {\n    webhookCreate(\n      input: {\n        name: "Checkout app payment notifications"\n        targetUrl: $targetUrl\n        events: [TRANSACTION_ACTION_REQUEST]\n        isActive: true\n        query: $query\n      }\n    ) {\n      errors {\n        ...WebhookErrorFragment\n      }\n    }\n  }\n  ',
        "\n"
    ]);
    _templateObject32 = function() {
        return data;
    };
    return data;
}
function _templateObject33() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query CheckWebhooks {\n    app {\n      webhooks {\n        id\n        targetUrl\n      }\n    }\n  }\n"
    ]);
    _templateObject33 = function() {
        return data;
    };
    return data;
}



const ChannelFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject());
const FileUploadErrorFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject1());
const MetadataErrorFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject2());
const AddressFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject3());
const MoneyFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject4());
const OrderLineFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject5(), MoneyFragmentDoc);
const OrderFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject6(), AddressFragmentDoc, MoneyFragmentDoc, OrderLineFragmentDoc);
const TransactionEventFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject7());
const TransactionFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject8(), MoneyFragmentDoc, TransactionEventFragmentDoc);
const TransactionActionPayloadFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject9());
const WebhookErrorFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject10());
const AppDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject11());
function useAppQuery(options) {
    return Urql.useQuery({
        query: AppDocument,
        ...options
    });
}
const ChannelDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject12(), ChannelFragmentDoc);
function useChannelQuery(options) {
    return Urql.useQuery({
        query: ChannelDocument,
        ...options
    });
}
const ChannelsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject13(), ChannelFragmentDoc);
function useChannelsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .aM({
        query: ChannelsDocument,
        ...options
    });
}
const CheckoutDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject14(), MoneyFragmentDoc);
function useCheckoutQuery(options) {
    return Urql.useQuery({
        query: CheckoutDocument,
        ...options
    });
}
const FileUploadDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject15(), FileUploadErrorFragmentDoc);
function useFileUploadMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .Db(FileUploadDocument);
}
const PublicMetafieldsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject16());
function usePublicMetafieldsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .aM({
        query: PublicMetafieldsDocument,
        ...options
    });
}
const PrivateMetafieldsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject17());
function usePrivateMetafieldsQuery(options) {
    return Urql.useQuery({
        query: PrivateMetafieldsDocument,
        ...options
    });
}
const PublicMetafieldsInferedDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject18());
function usePublicMetafieldsInferedQuery(options) {
    return Urql.useQuery({
        query: PublicMetafieldsInferedDocument,
        ...options
    });
}
const PrivateMetafieldsInferedDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject19());
function usePrivateMetafieldsInferedQuery(options) {
    return Urql.useQuery({
        query: PrivateMetafieldsInferedDocument,
        ...options
    });
}
const UpdatePublicMetadataDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject20(), MetadataErrorFragmentDoc);
function useUpdatePublicMetadataMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .Db(UpdatePublicMetadataDocument);
}
const UpdatePrivateMetadataDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject21(), MetadataErrorFragmentDoc);
function useUpdatePrivateMetadataMutation() {
    return Urql.useMutation(UpdatePrivateMetadataDocument);
}
const OrderCreateDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject22(), OrderFragmentDoc);
function useOrderCreateMutation() {
    return Urql.useMutation(OrderCreateDocument);
}
const OrderDetailsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject23(), OrderFragmentDoc);
function useOrderDetailsQuery(options) {
    return Urql.useQuery({
        query: OrderDetailsDocument,
        ...options
    });
}
const OrderPaymentDetailsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject24());
function useOrderPaymentDetailsQuery(options) {
    return Urql.useQuery({
        query: OrderPaymentDetailsDocument,
        ...options
    });
}
const OrderUpdatePaymentMetafieldDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject25());
function useOrderUpdatePaymentMetafieldMutation() {
    return Urql.useMutation(OrderUpdatePaymentMetafieldDocument);
}
const OrderTransactionsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject26(), TransactionFragmentDoc);
function useOrderTransactionsQuery(options) {
    return Urql.useQuery({
        query: OrderTransactionsDocument,
        ...options
    });
}
const TransactionCreateDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject27());
function useTransactionCreateMutation() {
    return Urql.useMutation(TransactionCreateDocument);
}
const TransactionUpdateDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject28());
function useTransactionUpdateMutation() {
    return Urql.useMutation(TransactionUpdateDocument);
}
const TransactionProcessedEventsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject29());
function useTransactionProcessedEventsQuery(options) {
    return Urql.useQuery({
        query: TransactionProcessedEventsDocument,
        ...options
    });
}
const TransactionUpdateProcessedEventsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject30());
function useTransactionUpdateProcessedEventsMutation() {
    return Urql.useMutation(TransactionUpdateProcessedEventsDocument);
}
const TransactionActionRequestSubscriptionDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject31());
function useTransactionActionRequestSubscription() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, handler = arguments.length > 1 ? arguments[1] : void 0;
    return Urql.useSubscription({
        query: TransactionActionRequestSubscriptionDocument,
        ...options
    }, handler);
}
const CreateWebhooksDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject32(), WebhookErrorFragmentDoc);
function useCreateWebhooksMutation() {
    return Urql.useMutation(CreateWebhooksDocument);
}
const CheckWebhooksDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject33());
function useCheckWebhooksQuery(options) {
    return Urql.useQuery({
        query: CheckWebhooksDocument,
        ...options
    });
}


/***/ }),

/***/ 25590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ channels; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./frontend/components/elements/AppNavigation/index.ts + 2 modules
var AppNavigation = __webpack_require__(68956);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@saleor+macaw-ui@0.6.7_vdvb7n236vx4s4shxyxtl27fte/node_modules/@saleor/macaw-ui/dist/esm/index.js + 57 modules
var esm = __webpack_require__(50145);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.4_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(13220);
// EXTERNAL MODULE: ./routes.ts
var routes = __webpack_require__(57032);
;// CONCATENATED MODULE: ./frontend/components/templates/ChannelList/styles.tsx

const useStyles = (0,esm/* makeStyles */.ZL)((theme)=>({
        listItem: {
            height: "70px",
            cursor: "pointer"
        },
        listItemSkeleton: {
            margin: theme.spacing(0, 4)
        }
    }), {
    name: "ChannelList"
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react-intl@6.2.1_uz2ogxeagc4rbieizlfzyaazee/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(22710);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-intl@6.2.1_uz2ogxeagc4rbieizlfzyaazee/node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(84841);
;// CONCATENATED MODULE: ./frontend/components/templates/ChannelList/messages.ts

const messages = (0,lib/* defineMessages */.vU)({
    channelName: {
        defaultMessage: "Channel name",
        id: "ChannelList/messages/vOL1vk",
        description: "label"
    }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+lab@4.0.0-alpha.61_l4woruyscjh25lcwxfwsoghpdm/node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(987);
;// CONCATENATED MODULE: ./frontend/components/templates/ChannelList/ChannelList.tsx









const ChannelList = (param)=>{
    let { channels , loading  } = param;
    const router = (0,next_router.useRouter)();
    const classes = useStyles();
    const onChannelClick = (channel)=>{
        void router.push({
            pathname: routes/* channelPath */.kK,
            query: {
                channelId: channel.id
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNavigation/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* OffsettedList */.Xsf, {
                gridTemplate: [
                    "1fr"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* OffsettedListHeader */.MaK, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* OffsettedListItem */.fqb, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* OffsettedListItemCell */.zP$, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    ...messages.channelName
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* OffsettedListBody */.SrY, {
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* OffsettedListItem */.fqb, {
                            className: classes.listItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: classes.listItemSkeleton
                            })
                        }) : channels.map((channel)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* OffsettedListItem */.fqb, {
                                className: classes.listItem,
                                onClick: ()=>onChannelClick(channel),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* OffsettedListItemCell */.zP$, {
                                    children: channel.name
                                })
                            }, channel.id))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ChannelList_ChannelList = (ChannelList);

;// CONCATENATED MODULE: ./frontend/components/templates/ChannelList/index.ts



// EXTERNAL MODULE: ./graphql/index.ts
var graphql = __webpack_require__(32026);
// EXTERNAL MODULE: ./frontend/hooks/useAuthData.ts
var useAuthData = __webpack_require__(73754);
;// CONCATENATED MODULE: ./pages/channels.tsx




const Channels = ()=>{
    var ref;
    const { isAuthorized  } = (0,useAuthData/* useAuthData */.q)();
    const [channelsQuery] = (0,graphql/* useChannelsQuery */.jI)({
        pause: !isAuthorized
    });
    const channels = ((ref = channelsQuery.data) === null || ref === void 0 ? void 0 : ref.channels) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelList_ChannelList, {
        channels: channels,
        loading: channelsQuery.fetching
    });
};
/* harmony default export */ var channels = (Channels);


/***/ }),

/***/ 57032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$N": function() { return /* binding */ channelListPath; },
/* harmony export */   "CG": function() { return /* binding */ customizationPath; },
/* harmony export */   "Iz": function() { return /* binding */ paymentProviderPath; },
/* harmony export */   "kK": function() { return /* binding */ channelPath; }
/* harmony export */ });
/* unused harmony export paymentProviderListPath */
const channelListPath = "/channels";
const channelPath = "/channels/[channelId]";
const paymentProviderListPath = "/payment-providers";
const paymentProviderPath = "/payment-providers/[paymentProviderId]";
const customizationPath = "/customization";


/***/ }),

/***/ 84841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vU": function() { return /* binding */ defineMessages; }
});

// UNUSED EXPORTS: FormattedDate, FormattedDateParts, FormattedDateTimeRange, FormattedDisplayName, FormattedList, FormattedListParts, FormattedMessage, FormattedNumber, FormattedNumberParts, FormattedPlural, FormattedRelativeTime, FormattedTime, FormattedTimeParts, IntlContext, IntlProvider, InvalidConfigError, MessageFormatError, MissingDataError, MissingTranslationError, RawIntlProvider, ReactIntlError, ReactIntlErrorCode, UnsupportedFormatterError, createIntl, createIntlCache, defineMessage, injectIntl, useIntl

// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(64062);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-intl@6.2.1_uz2ogxeagc4rbieizlfzyaazee/node_modules/react-intl/lib/src/components/useIntl.js
var components_useIntl = __webpack_require__(74622);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-intl@6.2.1_uz2ogxeagc4rbieizlfzyaazee/node_modules/react-intl/lib/src/components/createFormattedComponent.js



var DisplayName;
(function (DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function (DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function (props) {
    var intl = (0,components_useIntl/* default */.Z)();
    var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
var FormattedListParts = function (props) {
    var intl = useIntl();
    var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function (props) {
        var intl = (0,components_useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate'
            ? intl.formatDateToParts(date, formatProps)
            : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function (props) {
        var intl = (0,components_useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props
        // TODO: fix TS type definition for localeMatcher upstream
        , ["value", "children"]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') {
            return children(formattedValue);
        }
        var Text = intl.textComponent || react.Fragment;
        return react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-intl@6.2.1_uz2ogxeagc4rbieizlfzyaazee/node_modules/react-intl/lib/index.js










function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}
// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
var FormattedDate = createFormattedComponent('formatDate');
var FormattedTime = createFormattedComponent('formatTime');
var FormattedNumber = createFormattedComponent('formatNumber');
var FormattedList = createFormattedComponent('formatList');
var FormattedDisplayName = createFormattedComponent('formatDisplayName');
var FormattedDateParts = createFormattedDateTimePartsComponent('formatDate');
var FormattedTimeParts = createFormattedDateTimePartsComponent('formatTime');



/***/ }),

/***/ 22710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64062);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74622);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31673);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ }),

/***/ 74622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81422);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31673);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ }),

/***/ 15771:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4474,6112,9774,2888,179], function() { return __webpack_exec__(12236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);